import axios from 'axios';

export default {
    async search(term, forceRefresh = false, cart = null) {
        let cart_id = cart ? cart.id : null;
        var response = await axios.post('/quickscan/search', { term, forceRefresh, cart_id });
        return response.data;
    },
    async getLowestOffers(productId) {
        var response = await axios.get(`/quickscan/products/${productId}/lowestoffers`);
        return response.data;
    },
    async getFeesEstimate(productId) {
        var response = await axios.get(`/quickscan/products/${productId}/feesEstimate`);
        return response.data;
    },
    async getCompetitivePricing(productId) {
        var response = await axios.get(`/quickscan/products/${productId}/competitivepricing`);
        return response.data;
    },
    async getArBookFinder(productId) {
        var response = await axios.get(`/quickscan/products/${productId}/arbookfinder`);
        return response.data;
    },

    async searchWithFollowUps(term, cart, resultsCallback, productUpdateCallback) {
        // Perform the initial search
        let data = await this.search(term, false, cart);
        resultsCallback(data);

        // We may need to search again if we received outdated data
        if (!data.error && data.needsRefresh) {
            data = await this.search(term, true, cart);
            resultsCallback(data);
        }

        if (data.error)
            return;

        // Perform additional requests
        data.amazonProducts.forEach(async amazonProduct => {
            let data = await this.getLowestOffers(amazonProduct.id);
            productUpdateCallback({ amazonProduct: data.amazonProduct });

            if (!amazonProduct.competitive_pricing){
                data = await this.getCompetitivePricing(amazonProduct.id);
                productUpdateCallback({ amazonProduct: data.amazonProduct });
            }

            data = await this.getArBookFinder(amazonProduct.id);
            productUpdateCallback({ amazonProduct: data.amazonProduct });

            data = await this.getFeesEstimate(amazonProduct.id);
            productUpdateCallback({ amazonProduct: data.amazonProduct });
        });
    },
};
